import { useEffect } from 'react'
import { useTranslations } from '@npco/common-utils-translations'
import { showErrorToast } from '@npco/zeller-design-system'
import { useTransferMFAState } from 'features/MFA'

import { FALLBACK_TO_DE, useSendContactTransfer } from 'hooks/banking'
import {
  DAILY_TRANSFER_LIMIT_EXCEEDED,
  MFA_ERROR,
  UNEXPECTED_ERROR,
} from 'types/errors'

import { useTransferState } from '../../Transfer.context'
import { contactTransferTranslations } from '../../Transfer.i18n'
import { TransferEvent } from '../../Transfer.stateMachine'

export const useTransferOnMFARedirect = () => {
  const t = useTranslations(contactTransferTranslations)
  const { transferState, hasRedirectedBackToApp, setHasRedirectedBackToApp } =
    useTransferMFAState()

  const { sendContactTransfer } = useSendContactTransfer()

  const {
    transferState: [, send],
  } = useTransferState()

  useEffect(() => {
    if (transferState && hasRedirectedBackToApp) {
      const sendTransfer = async () => {
        const result = await sendContactTransfer(transferState.variables)

        if (result === DAILY_TRANSFER_LIMIT_EXCEEDED) {
          showErrorToast(t('dailyMaxLimitTransferError'))
          send(TransferEvent.Back)
          return
        }

        // As we have redirected back from MFA, another MFA error is treated
        // as an unexpected error
        if (result === MFA_ERROR || result === UNEXPECTED_ERROR) {
          send(TransferEvent.Error)
          return
        }

        if (result === FALLBACK_TO_DE) {
          send(TransferEvent.DeFallbackRetry)
          return
        }

        send(TransferEvent.Continue)
      }

      setHasRedirectedBackToApp(false)
      send(TransferEvent.TransferContactOnRedirect)
      sendTransfer()
    }
  }, [
    hasRedirectedBackToApp,
    send,
    sendContactTransfer,
    setHasRedirectedBackToApp,
    t,
    transferState,
  ])
}
